import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://pejrzgqapincpitydxfl.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBlanJ6Z3FhcGluY3BpdHlkeGZsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQ3OTM2NzksImV4cCI6MjA4MDM2OTY3OX0.HKVZgcVnYphNpU_ca8MvkDPnyslfmdOlvEIMSiTXPDU'

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Import the supabase client like this:
// For React:
// import { supabase } from "@/integrations/supabase/client";
// For React Native:
// import { supabase } from "@/src/integrations/supabase/client";
